import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia"; //store
import installElementPlus from "./plugins/element";
import installCustomComp from "@/components/index";
import installDirective from "@/directive/index";
import { VueReCaptcha } from "vue-recaptcha-v3";
import "normalize.css/normalize.css"; //  CSS resets
import "./styles/element-variables.scss";
import "@/utils/permission"; //ルーターガード設定

const app = createApp(App);
installElementPlus(app);
installCustomComp(app);
installDirective(app);

// reCAPTCHA v3
app.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY || "",
  loaderOptions: {
    // バッジは既定で非表示にし、reCAPTCHAを利用する画面(問い合わせ)でのみ表示する
    autoHideBadge: true,
  },
});

app.use(createPinia()).use(router).mount("#app");
